import config from '../nyConfig'
const ApiCompany = {
    "公司列表": new config({ url: '/company/listCompany', showSuccessMessage: false, useToken: true }),
    "冻结解冻公司": new config({ url: '/company/frozenCompany', showSuccessMessage: true, useToken: true }),
    "删除公司": new config({ url: '/company/delCompany', showSuccessMessage: true, useToken: true }),
    "添加公司": new config({ url: '/company/addCompany', showSuccessMessage: true, useToken: true }),
    "编辑公司": new config({ url: '/company/editCompany', showSuccessMessage: true, useToken: true }),
    "全部公司": new config({ url: '/company/listAll', showSuccessMessage: false, useToken: true }),
    "封面列表": new config({ url: '/company/listCover', showSuccessMessage: false, useToken: true }),
    "添加封面": new config({ url: '/company/addCover', showSuccessMessage: true, useToken: true }),
    "修改邮箱": new config({ url: '/company/editEmail', showSuccessMessage: true, useToken: true }),
    "导出档案": new config({ url: '/company/exportScore', showSuccessMessage: true, useToken: true }),
}

export default ApiCompany